/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { FormContext } from "../components/FormFull";
export default function useField(props) {
    var getInitialStringValue = React.useCallback(function () {
        var _a = props.defaultValue, defaultValue = _a === void 0 ? "" : _a, mask = props.mask;
        var value = defaultValue;
        var finalValue = mask ? mask(value) : value;
        return finalValue;
    }, [props]);
    var initialValue = getInitialStringValue();
    var _a = React.useState(initialValue), value = _a[0], setStateValue = _a[1];
    var _b = React.useState(false), formLoading = _b[0], setFormLoading = _b[1];
    var _c = React.useState(""), error = _c[0], setError = _c[1];
    var _d = React.useState(false), valid = _d[0], setValid = _d[1];
    var ref = React.useRef();
    var ffHandler = React.useContext(FormContext);
    var _e = React.useState(!!(ffHandler === null || ffHandler === void 0 ? void 0 : ffHandler.getDisabledForm())), formDisabled = _e[0], setFormDisabled = _e[1];
    var setValueWithoutOnChangeString = React.useCallback(function (value) {
        if (value === void 0) { value = ""; }
        var maxLength = props.maxLength, mask = props.mask, name = props.name;
        var maxLengthValue = value;
        if (maxLength && (value !== null || value !== undefined)) {
            maxLengthValue = String(value).substring(0, maxLength);
        }
        var resultedValue = mask ? mask(maxLengthValue) : maxLengthValue;
        ffHandler === null || ffHandler === void 0 ? void 0 : ffHandler.setFormValue(name, resultedValue);
        setStateValue(resultedValue);
        setValid(false);
    }, [ffHandler, props]);
    function onBlur(event) {
        setTimeout(function () {
            if (props.submitOnBlur) {
                ffHandler === null || ffHandler === void 0 ? void 0 : ffHandler.submit();
            }
            else {
                ffHandler === null || ffHandler === void 0 ? void 0 : ffHandler.testFieldError(props.name);
            }
            if (props.onBlur) {
                props.onBlur(value, ffHandler, event);
            }
        }, 10);
    }
    function testFieldError() {
        setTimeout(function () {
            ffHandler === null || ffHandler === void 0 ? void 0 : ffHandler.testFieldError(props.name);
        }, 10);
    }
    var onChange = React.useCallback(function (event, value) {
        setValueWithoutOnChangeString(value);
        if (props.onChange) {
            props.onChange(value, ffHandler, event);
        }
    }, [ffHandler, props, setValueWithoutOnChangeString]);
    var mount = React.useCallback(function () {
        var _a;
        ffHandler === null || ffHandler === void 0 ? void 0 : ffHandler.setNewField(props.name, {
            ref: ref.current,
            errorHandler: function (error) { return setError(error); },
            validHandler: function (valid) { return setValid(valid); },
            handleValue: function (value) { return onChange(null, value); },
            setLoading: function (loading) { return setFormLoading(loading); },
            disableHandler: function (disabled) { return setFormDisabled(disabled); },
            value: value,
            label: (_a = props.label) !== null && _a !== void 0 ? _a : props.placeholder,
            defaultValue: props.defaultValue,
            mask: props.mask,
            maskToSubmit: props.maskToSubmit,
            validation: props.validation,
            asyncValidation: props.asyncValidation,
            required: props.required,
        });
        return function () {
            ffHandler === null || ffHandler === void 0 ? void 0 : ffHandler.removeField(props.name);
        };
    }, [
        ffHandler,
        props,
        setError,
        setValid,
        setFormLoading,
        setFormDisabled,
        ref,
        value,
        onChange,
    ]);
    React.useEffect(mount, []);
    React.useEffect(function () {
        ffHandler === null || ffHandler === void 0 ? void 0 : ffHandler.setFieldRequired(props.name, props.required);
    }, [props, ffHandler]);
    function onSubmit(event) {
        if (!(event === null || event === void 0 ? void 0 : event.shiftKey) && (event === null || event === void 0 ? void 0 : event.charCode) === 13) {
            ffHandler === null || ffHandler === void 0 ? void 0 : ffHandler.submit();
        }
    }
    return {
        value: value,
        error: error,
        valid: valid,
        formLoading: formLoading,
        formDisabled: formDisabled,
        onSubmit: onSubmit,
        onBlur: onBlur,
        onChange: onChange,
        testFieldError: testFieldError,
        ref: ref,
        ffHandler: ffHandler,
    };
}
